module.exports = __webpack_public_path__ + "static/media/welcome.d1c21e43.svg";